
import saMessages from '../locales/hu_HU';

const huLang = {
   messages: {
      ...saMessages
   },
   locale: 'hu-hu',
 
};

export default huLang;